import { ConsignmentType } from './poz-consignment';

export class ConsignmentConfig {
  prefixConsignment: string = 'CS/{year}/';
  defaultConsignmentType: ConsignmentType = 'deposit';
  // Compliance product type preselected on the intake screen. Null means the
  // shop consigns plain products by default.
  defaultComplianceProductTypeId: number | null = null;
  consignmentHeader: string = '';
  consignmentFooter: string = '';
  additionalIntakeText: string = '';
  additionalReturnText: string = '';
  additionalPayoutStatementText: string = '';
  // Length of a deposit in days (end of the deposit proposed at intake), 0 for none
  defaultDurationDays: number | null = null;
  // The depositor told by email when the deposit ends (scheduled job)
  remindOnDue = false;
  // Agreed price lowered once, by this percent, after this many days on sale
  markdownAfterDays: number | null = null;
  markdownPercent: number | null = null;
  // The depositor told by email when the item is sold, with the payout statement
  notifyDepositorOnSale = false;
  // Commission proposed at intake: rate (or the rate of the price band), fixed amount
  defaultCommissionRate: number | null = null;
  defaultCommissionFixed: number | null = null;
  commissionTiers: { upTo: number | null; rate: number }[] = [];
  // VAT included in the commission (payout statement), none when empty
  commissionVatRate: number | null = null;
}
